import { populate } from "populate";

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "407a3db2-6146-45f2-a944-c7dcc249dbcb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "farm_popup",
      parent: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      data: ""
    },
    {
      id: "5d00e51c-c1da-4a1b-b852-749db6c0ceb2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "popup_title_bg",
      parent: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      data: ""
    },
    {
      id: "6a43e14f-b697-4d54-93f8-1e319fcacab6",
      type: "Container",
      name: "itemsContainer",
      nameSpace: "",
      className: "",
      x: -410,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      data: ""
    },
    {
      id: "be507dbd-f3c7-4303-aae0-7fbf1d653761",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -127,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "UnlockedNewItems",
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 35,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#bb3c2f",
        stroke: "black",
        strokeThickness: 0,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      data: ""
    },
    {
      id: "b1468994-4a2c-4467-ab8b-839c18fe6f27",
      type: "Sprite",
      name: "farmButton",
      nameSpace: "",
      className: "",
      x: -180,
      y: 285,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_orange",
      parent: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      data: ""
    },
    {
      id: "de41f3e8-7ef3-4336-952f-e1cdfe4fe441",
      type: "Sprite",
      name: "continueButton",
      nameSpace: "",
      className: "",
      x: 180,
      y: 285,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      texture: "button_medium_green",
      parent: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      data: ""
    },
    {
      id: "a4e88338-315b-48d0-8684-89a97fe8c288",
      type: "Sprite",
      name: "character",
      nameSpace: "",
      className: "",
      x: -540,
      y: 380,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "henry_farm_unlocks",
      parent: "ff4ab171-63d9-43ad-bd32-f335ea454d78",
      data: ""
    },
    {
      id: "5a1a5041-5356-4e4c-a32a-f4edb9af8799",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Congratulations",
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 45,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "white",
        stroke: "#ab3143",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "5d00e51c-c1da-4a1b-b852-749db6c0ceb2",
      data: ""
    },
    {
      id: "36952584-41f4-47e1-847e-73d25cf8755b",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "GoToFarm",
      localize: true,
      maxWidth: 220,
      maxHeight: 70,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "white",
        stroke: "#9b2813",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b1468994-4a2c-4467-ab8b-839c18fe6f27",
      data: ""
    },
    {
      id: "e095d896-6f94-449c-ac56-888aec94d5ec",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "Continue",
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "white",
        stroke: "#187630",
        strokeThickness: 5,
        align: "left",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "de41f3e8-7ef3-4336-952f-e1cdfe4fe441",
      data: ""
    }
  ]
} as const;

export class UnlockItemsPopupLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  itemsContainer: GameObject<PIXI.Container>;
  farmButton: GameObject<PIXI.Sprite>;
  continueButton: GameObject<PIXI.Sprite>;
  character: GameObject<PIXI.Sprite>;

  constructor() {
    populate(this, raw);
  }
}
